import { render, staticRenderFns } from "./category.vue?vue&type=template&id=63631a82&scoped=true"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63631a82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63631a82')) {
      api.createRecord('63631a82', component.options)
    } else {
      api.reload('63631a82', component.options)
    }
    module.hot.accept("./category.vue?vue&type=template&id=63631a82&scoped=true", function () {
      api.rerender('63631a82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/healthManagement/category.vue"
export default component.exports